import React from 'react'

const RecentActivitySection = () => {
  return <div></div>
}

export default RecentActivitySection
